import { utils, user } from 'lib';
import { cryolite } from 'lib/request';
import { getRangeNum } from 'lib/utils';

export default function redirectRoom() {
  cryolite.get('api/v5/homes').then((res: any) => {
    let max = res.data.recommed_rooms.length - 1;
    max = max > 4 ? 4 : max;
    // top5的主播随机跳转
    const roomId = res.data.recommed_rooms[getRangeNum(0, max)].id;
    const { pay } = utils.parseQueryString() as any;

    location.href = `/${roomId}?from=${user.getQdInfo().qd || 'baidudasou'}${pay ? '&pay=1' : ''}`;
  });
}
